import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '@/components/AppLayout';
import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { AdminRoute } from '@/routes/AdminRoute';
import { Spinner } from '@/components/Spinner';

const LoginPage = lazy(() => import('@/features/auth/LoginPage'));
const LoginCallbackPage = lazy(() => import('@/features/auth/LoginCallbackPage'));
const OnboardingPage = lazy(() => import('@/features/onboarding/OnboardingPage'));
const ProcessosPage = lazy(() => import('@/features/processos/ProcessosPage'));
const MetasPage = lazy(() => import('@/features/metas/MetasPage'));
const PerfilPage = lazy(() => import('@/features/perfil/PerfilPage'));
const TokensPage = lazy(() => import('@/features/tokens/TokensPage'));
const NotificacoesPage = lazy(() => import('@/features/notificacoes/NotificacoesPage'));
const AdminPage = lazy(() => import('@/features/admin/AdminPage'));

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="p-6">
            <Spinner />
          </div>
        }
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* Retorno do login Microsoft: recebe o token no fragmento da URL. */}
          <Route path="/login/callback" element={<LoginCallbackPage />} />
          {/* Onboarding fica protegida (precisa JWT) mas SEM o AppLayout - usuário
              não pode usar a navbar até completar. */}
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            }
          />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<ProcessosPage />} />
            <Route path="metas" element={<MetasPage />} />
            <Route path="perfil" element={<PerfilPage />} />
            <Route path="tokens" element={<TokensPage />} />
            <Route path="notificacoes" element={<NotificacoesPage />} />
            <Route
              path="admin"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
